<template>
    <div>
        <header class="header">
            <div class="header-top flex flex-bet inner">
                <div class="w32 header-logo">
                    <router-link style="display: unset" :to="homeUrl"><p class="img-logo"><img src="../../images/top/sensei_logo.png" class="img-logo img-logo-resize" alt="レガシィマネジメントグループ"></p></router-link>
                    <div class="header-logo-content-wrapper">
                        <p id="hoge" class="title">相続の不安を専門家が解決するプラットフォーム</p>
                        <a class="link-legacy" href="https://legacy.ne.jp/company/company03/" target="_blank" rel="noopener noreferrer">
                            <img  class="gtm_top_lgmg_top" src="../../images/top/logo.png" alt="レガシィマネジメントグループ" width="230" height="20">
                        </a>
                    </div>
                </div>
                <div class="w68 header-content d-flex flex-column justify-content-end">
                    <div class="flex w-100 header-flex">
                        <div class="user-info padding-content-user-register d-flex" v-if="isAuthenticated">
                            <div style="padding-right: 10px"><div class="fullname">{{ currentUser.lastName }} {{ currentUser.firstName }}様専用画面</div></div>
                            <div class="header-btn-left" style="min-width: 86px"><div class="btn-logout" @click="logout">ログアウト</div></div>
                        </div>
                        <div class="register-info padding-content-user-login d-flex" v-else-if="!hiddenRegisterHeader">
                            <div class="btn-register item-flex-equal-width gtm_top_touroku_top" style="margin-right: 10px" @click="registerEmail">無料会員登録</div>
                            <div class="header-btn-left item-flex-equal-width"><div class="btn-logout" @click="openLoginDialog">ログイン</div></div>
                        </div>
                        <div class="header-content-right header-content-inform" v-show="!hiddenRegisterHeader">
                            <div class="item-flex-equal-width item-header-right item-header-right-contact">
                                <router-link to="/contact" tag="div" style="width: 100%; cursor: pointer" class="gtm_top_inquiry_top">
                                    お問い合わせ
                                    <br>
                                        フォーム
                                </router-link>
                            </div>
                            <div class="item-flex-equal-width item-header-right item-header-right-tel">
                                 <div style="width: 100%">
                                     無料相談<br>
                                     <a href="tel:0120-501-725" class="gtm_top_tel_top" style="color: #fff"> 0120-501-725</a>
                                 </div>
                            </div>

                        </div>
                    </div>
                    <nav-cl class="w-100" v-if="!hiddenNavMenu"></nav-cl>
                </div>
            </div>
        </header>
        <!-- Login Dialog -->
        <Login :dialogVisible="isOpenLoginDialog" />
        <!--register-->
        <register-email :dialogVisible="isOpenRegisterDialog"></register-email>
        <!--register-->
    </div>
</template>
<script>
    import Nav from './Nav.vue'
    import Login from '../../views/pages/client/login/Login.vue'
    import { mapGetters } from 'vuex'
    import { LOGOUT_CLIENT, SET_OPEN_LOGIN_DIALOG, SET_OPEN_REGISTER_DIALOG } from '@/store/actions.type'
    import RegisterEmail from '@/views/pages/client/register_email/RegisterEmail'
    import { isIE } from '@/common/useragent'
    export default {
        name: 'header-top',
        data () {
            return {
                homeUrl: '',
                dialogVisible: false
            }
        },
        components: {
            'nav-cl': Nav,
            Login,
            'register-email': RegisterEmail
        },
        computed: {
            ...mapGetters(['currentUser', 'isAuthenticated', 'isOpenLoginDialog', 'hiddenNavMenu', 'isOpenRegisterDialog', 'hiddenRegisterHeader'])
        },
        methods: {
            logout () {
                this.$store.dispatch(LOGOUT_CLIENT).then(() => {
                    this.$router.push({ name: 'portal' })
                })
            },
            openLoginDialog () {
                this.$store.dispatch(SET_OPEN_LOGIN_DIALOG, true)
            },
            register () {
                const path = `/member/register`
                if (this.$route.path !== path) {
                    this.$router.push(path)
                }
            },
            registerEmail () {
                this.$store.dispatch(SET_OPEN_REGISTER_DIALOG, true)
            }
        },
         created () {
            if (this.isAuthenticated) { this.homeUrl = '/portal-member' } else { this.homeUrl = '/portal' }
        },
        mounted () {
            let hiddenNavMenu = this.hiddenNavMenu
            let $ = this._$
            /******************************************
             初期処理
             ******************************************/
            let winW = $(window).width()
            let winH = $(window).height()
            // windowのスクロール位置
            let headerHeight = $('.header').outerHeight()
            $('.btn-sub-menu').on('click', function () {
                $('.v-modal').css({
                    'z-index': 'unset'
                })
            })
            /* スマホ */
            if (winW <= 768) {
                $('.gnav,.gnav-menu').height(winH - headerHeight)
                $('.btn-menu,.gnav-bg').on('click', function () {
                    $('.gnav').toggleClass('on')
                    $('.submenu').slideUp()
                })
            }
            /******************************************
             window load
             ******************************************/
            $(window).on('load', function () {
            })
            /******************************************
             window resize
             ******************************************/
            $(window).on('resize', function () {
                winW = $(window).width()
                winH = $(window).height()
                $('.header, .gnav').css({
                    'width': winW
                })
            })
            /******************************************
             window scroll
             ******************************************/
            $(window).on('scroll', function () {
                if (hiddenNavMenu) {
                    return
                }

                let winScrolltop = $(window).scrollTop()
                headerHeight = $('.header').outerHeight()
                let winW = $(window).width()
                let winH = $(window).height()
                if (winScrolltop > 140) {
                    if (winW > 600 && winH > 400) {
                        $('.header-top .header-content .gnav').css({ 'position': 'fixed', 'top': 0, 'max-width': '650.08px' }).show(1000)
                        if (isIE()) {
                            $('.header-top .header-content .gnav ul.submenu').css({ 'min-width': '900px', 'left': 'auto', 'right': '4%' })
                        } else {
                            $('.header-top .header-content .gnav ul.submenu').css({ 'min-width': '900px', 'left': 'unset', 'right': '4%' })
                        }
                        $('.header-top .header-logo p').css({ 'text-align': 'left' })
                        $('.header-top .header-logo p.img-logo').css({
                            'position': 'fixed',
                            'top': 0,
                            'max-width': '308.91px',
                            'max-height': '65px',
                            'min-width': '326.91px'
                        }).show(1000)
                    }
                }
                if (winScrolltop < 170) {
                    $('.header-top .header-content .gnav').css({ 'position': 'static', 'top': 'unset', 'max-width': 'unset' })
                    if (isIE()) {
                        $('.header-top .header-content .gnav ul.submenu').css({ 'min-width': 'unset', 'left': 'auto', 'right': '4%' })
                    } else {
                        $('.header-top .header-content .gnav ul.submenu').css({ 'min-width': 'unset', 'left': 0, 'right': 0 })
                    }
                    if (isIE()) {
                        $('.header-top .header-logo p').css({ 'text-align': 'left' })
                    } else {
                        $('.header-top .header-logo p').css({ 'text-align': 'center' })
                    }
                    $('.header-top .header-logo p.img-logo').css({
                        'position': 'unset',
                        'top': 'unset',
                        'max-width': 'unset',
                        'max-height': 'unset',
                        'min-width': 'unset'
                    })
                }
            })
        }
    }
</script>
<style>
    @import "../../assets/css/client.css";
    @media all and (-ms-high-contrast: none) {
        .header-logo-content-wrapper {
            margin-top: 40px;
        }
    }
    .header {
        clear: both;
        z-index: 999
    }
    .header-content {
        overflow: hidden;
    }
    .user-info .fullname, .btn-login {
        background-color: #a5272a;
        color: #ffffff;
        font-weight: bold;
        padding: 0.2em 0.5em;
        text-align: center;
        border-radius: 5px;
        border: 1px solid #a5272a;
    }
    .btn-login {
        padding: 0.2em 1.1em;
    }

    .register-info{
        width: 250px;
    }
    .register-info .btn-register:hover {
        cursor: pointer;
    }
    .user-info .btn-logout,
    .register-info .btn-logout,
    .inquiry .btn-logout{
        color: #8a0602;
        border: 1px solid #8a0602;
        font-weight: bold;
        padding: 0.2em 0.5em;
        text-align: center;
        border-radius: 5px;
    }

    .register-info .btn-logout {
        padding: 3px 0px
    }

    .user-info .btn-logout,
    .register-info .btn-logout{
        cursor: pointer;
    }
    .user-info .btn-logout:hover {
        color: #a5272a;
    }

    .register-info .btn-register{
        background-color: #a5272a;
        color: #ffffff;
        font-weight: bold;
        padding: 3px 0px;
        text-align: center;
        border-radius: 5px;
        margin-right: 10px;
        border: 1px solid #a5272a;
    }
    .header-content-inform .inquiry {
        text-align: center;
    }
    .header-content-inform .inquiry a{
        font-size: 14px;
        text-align: left;
        font-style: normal;
        color: rgb(138, 6, 2);
        overflow: visible;
        font-weight: bold;
    }
    .header-content-inform .logo-header p{
        font-size: 10px;
        color: #c7bf93;
    }
    .header-content-inform, .header-content-user {
        position: relative;
    }
    /*.header-content-inform .inquiry,*/
    /*.header-content-inform .logo-header{*/
    /*position: absolute;*/
    /*bottom: 10px;*/
    /*}*/
    .header-content-user div.user-info,
    .header-content-user div.register-info {
        float: right;
        width: 100%;
        position: absolute;
        bottom: 0px;
    }
    .header-content-inform .logo-header{
        right: 0;
        padding: 4px 5px 3px 5px;
    }
    .header-content-inform .logo-header svg{
        float: right;
    }
    .header-logo {
        position: relative;
        text-align: center;
        padding-top: 15px;
    }
    .header-logo a {
        display: block;
        height: 20px;
        text-align: center;
    }
    .header-logo p.title {
        width: 100%;
        text-align: center;
    }
    .header-logo p.img-logo {
        width: 100%;
        text-align: center;
        background-color: #ffffff;
    }
    .header-logo svg {
        bottom: 40px;
    }
    .header-logo p {
        font-size: 13px;
        line-height: unset;
    }
    .logo-header-not-login {
        background: #a5272a;
    }
    .header-content-inform .logo-header p.colorCCC{
        color: #cccccc;
    }
    .logo-header-not-lg .logo-header-not-lg-l {
        height: auto;
        position: relative;
        width: 100%;
    }
    .logo-header-not-lg-l p.colorCCC {
        font-size: 10px;
    }

    .logo-header-not-lg-l p.colorCCC span.left{
        width: 65%;
    }
    .logo-header-not-lg-l p.colorCCC span.right{
        width: 35%;
    }
    .logo-header-not-lg .logo-header-not-lg-r{
        width: 35%;
        min-height: 50px;
    }
    .logo-header-not-lg-r {
        position: relative;
    }
    .logo-header-not-lg-r button{
        padding: 5px 8px;
        border-radius: 2px;
        border: none;
        position:absolute;
        bottom: 5px;
        color: #000000;
    }
    .header-content-inform .logo-header p {
        line-height: unset;
    }
    .header-content-inform .logo-header p.logo-header-not-lg-phone {
        color: #ffffff;
        font-size: 12px;
    }
    .logo-header-not-lg-phone i.el-icon-phone{
        background: #a5272a;
        color: #ffffff;
    }
    .logo-header-not-lg-phone a,
    .logo-header-not-lg-phone a:hover {
        color: #ffffff;
        opacity: 1;
    }
    .header-content {
        font-size: 14px;
    }
    .header-content-left {
        width: 55%;
        position: relative;
        right: 0;
    }
    .header-content-right {
        display: flex;
        align-items: center;
        width: 280px;
    }

    .inquiry-left{
        margin-bottom: 4px
    }

    .inquiry-left span{
        background: #8a0602;
        padding: 4px 15px;
        color: #ffffff;
        font-weight: 400;
    }
    .inquiry-left i.el-icon-message {
        font-size: 16px;
        margin-right: 5px;
    }
    .inquiry-right-img {
        position: absolute;
        bottom: 12px;
        width: 50%;
    }
    .btn-sub-menu {
        margin-top: 4px;
    }
    .gnav-menu li.gnav-menu-item {
        display: inline-block;
        height: 65px;
    }
    .nav-smart-phone .gnav-menu-item p{
        font-size: 18px;
        padding-top: 11px;
    }
    .nav-smart-phone .gnav-menu-item .submenu li.submenu-item p{
        font-size: 14px;
    }
    .nav-smart-phone li.first-child {
        min-height: 45px;
    }
    .display-on-pc{
        display: block;
    }
    .display-on-phone{
        display: none;
    }
    .resize-img{
        height: auto;
        bottom: 0px;
        max-height: 35px;
        object-fit: contain;
    }

    .padding-content-user-register {
        padding-right: 10px;
        align-items: center;
    }

    .padding-content-user-login {
        align-items: center;
    }

    .item-header-right-contact {
        margin-top: 4px;
        margin-right: 10px;
    }
    .item-header-right-tel {
        margin-top: 4px;
    }

    @media screen and (min-width:551px) {
        .padding-content-user-login {
            padding-right: 10px;
        }
        .item-header-right-contact {
            margin-right: 5px;
        }
    }

    .img-logo-resize {
        width: 295px;
        height: 65px;
    }

    .header-flex {
        align-items: center;
        justify-content: flex-end;
        flex-wrap: nowrap
    }

    .item-flex-equal-width {
        flex-grow: 1;
        flex-basis: 0;
    }
    @media screen and (max-width:940px){
        .inquiry-left span {
            padding: 4px 15px;
        }
        .header-content-inform .inquiry a {
            font-size: 13px;
        }

        .user-info .btn-logout,
        .user-info .fullname{
            font-size: 13px;
        }
        .nav-smart-phone .gnav-menu-item p{
            font-size: 14px;
            padding-top: 15px;
        }
    }

    @media screen and (min-width:769px) and (max-width:935px){
        .img-logo-resize {
            width: 100%;
            height: auto;
            object-fit: contain;
        }
    }

    @media screen and (max-width:768px){
        .header-logo, .header-logo svg, .header-logo p {
            width: 100%;
        }
        .header-content-inform .inquiry a {
            font-size: 13px;
        }

        .user-info .btn-logout,
        .user-info .fullname{
            font-size: 13px;
        }

        .header-logo svg {
            bottom: 60px;
        }
        .nav-smart-phone .gnav-menu-item p{
            font-size: 20px;
            padding-top: 10px;
        }

        .header-flex {
            justify-content: center;
        }
    }

    @media screen and (max-width:550px){
        .logo-header-not-lg-l p.colorCCC span{
            font-size: 8px;
        }
        .header-top .header-content .flex .header-content-user {
            padding-top: 5px;
        }
        .header-content-inform .logo-header p.logo-header-not-lg-phone {
            font-size: 9px;
        }
        .header-content-inform .logo-header {
            right: 20%;
            padding: 2px 10px 2px 10px;
        }
        .header-content-inform .inquiry {
            text-align: right;
        }
        .header-content-left .user-info {
            text-align: center;
        }
        .inquiry-left span {
            padding: 8px 10px;
            font-size: 12px;
        }
        .register-info .btn-register,
        .user-info .btn-logout,
        .register-info .btn-logout,
        .user-info .fullname,
        .btn-login {
            font-size: 12px;
        }
        .inquiry-left i.el-icon-message{
            font-size: 16px;
        }
        .header-content-inform .inquiry a {
            font-size: 8px;
        }
        .gnav {
            display: block;
            max-height: 45px !important;
        }
        .header-content-left {
            width: 100%;
        }
        .header-top .header-content .flex {
            min-height: 80px;
        }
        .nav-height {
            height: 45px;
        }
        .nav-smart-phone li.gnav-menu-item {
            height: unset;
        }
        .display-on-pc{
            display: none !important;
        }
        .display-on-phone{
            display: block !important;
        }

        .register-info{
            text-align: center;
        }

        .header-flex {
            flex-flow: column;
            padding-top: 8px;
        }

        .header-content-right {
            margin-top: 5px;
            justify-content: space-evenly;
        }

        .inquiry-left {
            margin-bottom: 2px;
        }

        .header-btn-left {
            min-width: unset !important;
        }
    }
    @media screen and (max-width:420px){
        .header-content-left .user-info,
        .header-content-user .register-info{
            text-align: center;
        }
        .header-content-inform .inquiry a {
            font-size: 8px;
        }
        .header-content-inform .logo-header svg {
            width: 80px;
        }
        .gnav {
            display: block;
            max-height: 45px !important;
        }
        .inquiry-left i.el-icon-message{
            font-size: 14px;
        }
        .nav-height {
            height: 45px;
        }
        .nav-smart-phone li.gnav-menu-item {
            height: unset;
        }
        .header-content-inform .logo-header {
            right: 20%;
            padding: 2px 10px 2px 10px;
        }
        .header-top .header-content .flex .header-content-user {
            padding-top: 5px;
        }
    }
    @media screen and (max-width:320px){
        .header-content-inform .logo-header {
            right: 15%;
            padding: 1px 10px 2px 10px;
        }
        .header-content-left .user-info {
            text-align: center;
        }
        .header-content-inform .inquiry a {
            font-size: 8px;
        }
        .header-content-inform .logo-header svg {
            width: 80px;
        }
        .gnav {
            display: block;
            max-height: 45px !important;
        }
        .inquiry-left span {
            padding: 9px 10px;
            font-size: 10px;
        }
        .register-info .btn-register,
        .user-info .btn-logout,
        .register-info .btn-logout,
        .user-info .fullname,
        .btn-login {
            font-size: 8px;
        }
        .inquiry-left i.el-icon-message{
            font-size: 12px;
        }
        .nav-height {
            height: 45px;
        }
        .nav-smart-phone li.gnav-menu-item {
            height: unset;
        }
    }
    @media screen and (max-width:300px) {
        .header-content-inform .logo-header {
            right: 5%;
            padding: 1px 10px 2px 10px;
        }

    }
    @media screen and (min-width:551px)  and (max-width:851px) {
        .gnav-menu li.gnav-menu-item {
            height: unset;
        }
        .nav-smart-phone {
            padding-bottom: 50px;
        }
    }
    @media screen and (min-height: 250px) and (max-height:350px){
        .header-content-left .user-info {
            text-align: center;
        }
        .el-drawer__body .nav-smart-phone {
            max-height: 250px;
        }
        .inquiry-left span {
            font-size: 12px;
        }
        .logo-header-not-lg-l p.colorCCC {
            padding-top: unset;
        }
        .register-info .btn-register,
        .user-info .btn-logout,
        .register-info .btn-logout,
        .user-info .fullname,
        .btn-login {
            font-size: 8px;
        }
        .inquiry-left span,
        .inquiry-left i.el-icon-message{
            font-size: 8px;
        }
        .nav-smart-phone li.gnav-menu-item {
            height: unset;
        }
        .header-content-inform .logo-header {
            padding: 0 10px;
        }
    }
    @media screen and (min-height: 351px) and (max-height:400px){
        .el-drawer__body .nav-smart-phone {
            max-height: 350px;
        }
        .nav-height {
            height: 45px;
        }
    }

    @media screen and (min-height: 401px) and (max-height:450px){
        .el-drawer__body .nav-smart-phone {
            max-height: 380px;
        }
        .nav-height {
            height: 45px;
        }
    }

    @media screen and (min-height: 451px)  and (max-height:510px){
        .el-drawer__body .nav-smart-phone {
            max-height: 430px;
        }
        .nav-height {
            height: 45px;
        }
    }

    @media screen and (min-height: 510px)  and (max-height:600px){
        .el-drawer__body .nav-smart-phone {
            max-height: 480px;
        }
    }

    @media screen and (min-height: 601px)  and (max-height:650px){
        .el-drawer__body .nav-smart-phone {
            max-height: 550px;
        }
        .gnav-menu li.gnav-menu-item {
            height: unset;
        }
    }

    @media screen and (min-height: 651px)  and (max-height:700px){
        .el-drawer__body .nav-smart-phone {
            max-height: 600px;
        }
    }

    @media screen and (min-height: 701px)  and (max-height:1100px){
        .el-drawer__body .nav-smart-phone {
            max-height: 650px;
        }
        .gnav-menu li.gnav-menu-item {
            height: unset;
            padding-bottom: 5px;
        }
    }
    @import "../../assets/css/client_custom.css";
</style>
